import { v4 as uuidv4 } from 'uuid'
import { genPrompt } from '@/api/prompt'
import { genOssImage } from '@/utils/ossPath'
import { Message } from 'element-ui'
import { getLastUsedBaseUrl, cudaIndexNum } from '@/utils/comfyUiRequest'
import axios from 'axios'
import cuda from '@/utils/checkCuda'
import random from 'random'
import { OSS_ACCESS_KEY_ID, OSS_ACCESS_KEY_SECRET } from '@/utils/secretCrypto'
function boardpicture(imagePath, progressCallback) {
  return new Promise((resolve, reject) => {
    const imageList = []
    const seed = Math.floor(Math.random() * 100000000000000)
    const filename = `["tmp-comfyui/${String(Date.now()) + String(random.int(1, 99999))}.png"]`
    const promptData = {
      11: {
        inputs: {
          conditioning: [
            '18',
            0
          ]
        },
        class_type: 'ConditioningZeroOut',
        _meta: {
          title: 'ConditioningZeroOut'
        }
      },
      12: {
        inputs: {
          samples: [
            '19',
            0
          ],
          vae: [
            '16',
            0
          ]
        },
        class_type: 'VAEDecode',
        _meta: {
          title: 'VAE Decode'
        }
      },
      13: {
        inputs: {
          clip_name1: 'clip_l.safetensors',
          clip_name2: 't5xxl_fp8_e4m3fn.safetensors',
          type: 'flux',
          device: 'default'
        },
        class_type: 'DualCLIPLoader',
        _meta: {
          title: 'DualCLIPLoader'
        }
      },
      14: {
        inputs: {
          guidance: 30,
          conditioning: [
            '20',
            0
          ]
        },
        class_type: 'FluxGuidance',
        _meta: {
          title: 'FluxGuidance'
        }
      },
      15: {
        inputs: {
          model: [
            '17',
            0
          ]
        },
        class_type: 'DifferentialDiffusion',
        _meta: {
          title: 'Differential Diffusion'
        }
      },
      16: {
        inputs: {
          vae_name: 'ae.safetensors'
        },
        class_type: 'VAELoader',
        _meta: {
          title: 'Load VAE'
        }
      },
      17: {
        inputs: {
          unet_name: 'gguf-fill/flux1-fill-dev-Q8_0.gguf'
        },
        class_type: 'UnetLoaderGGUF',
        _meta: {
          title: 'Unet Loader (GGUF)'
        }
      },
      18: {
        inputs: {
          text: '',
          clip: [
            '13',
            0
          ]
        },
        class_type: 'CLIPTextEncode',
        _meta: {
          title: 'CLIP Text Encode (Prompt)'
        }
      },
      19: {
        inputs: {
          seed: seed,
          steps: 20,
          cfg: 1,
          sampler_name: 'euler',
          scheduler: 'normal',
          denoise: 1,
          model: [
            '15',
            0
          ],
          positive: [
            '23',
            0
          ],
          negative: [
            '23',
            1
          ],
          latent_image: [
            '23',
            2
          ]
        },
        class_type: 'KSampler',
        _meta: {
          title: 'KSampler'
        }
      },
      20: {
        inputs: {
          text: '',
          clip: [
            '13',
            0
          ]
        },
        class_type: 'CLIPTextEncode',
        _meta: {
          title: 'CLIP Text Encode (Prompt)'
        }
      },
      22: {
        inputs: {
          images: [
            '12',
            0
          ]
        },
        class_type: 'PreviewImage',
        _meta: {
          title: 'Preview Image'
        }
      },
      23: {
        inputs: {
          noise_mask: false,
          positive: [
            '20',
            0
          ],
          negative: [
            '18',
            0
          ],
          vae: [
            '16',
            0
          ],
          pixels: [
            '26',
            0
          ],
          mask: [
            '26',
            1
          ]
        },
        class_type: 'InpaintModelConditioning',
        _meta: {
          title: 'InpaintModelConditioning'
        }
      },
      26: {
        inputs: {
          left: 256,
          top: 256,
          right: 256,
          bottom: 256,
          feathering: 64,
          image: [
            '42',
            0
          ]
        },
        class_type: 'ImagePadForOutpaint',
        _meta: {
          title: 'Pad Image for Outpainting'
        }
      },
      27: {
        inputs: {
          images: [
            '26',
            0
          ]
        },
        class_type: 'PreviewImage',
        _meta: {
          title: 'Preview Image'
        }
      },
      41: {
        inputs: {
          filename: filename,
          access_key_id: OSS_ACCESS_KEY_ID,
          access_key_secret: OSS_ACCESS_KEY_SECRET,
          security_token: '',
          bucket_name: 'mj-comfy-ui',
          endpoint: 'oss-cn-shenzhen.aliyuncs.com',
          image: [
            '12',
            0
          ]
        },
        class_type: 'OSSUploadNode',
        _meta: {
          title: '保存图片到oss'
        }
      },
      42: {
        inputs: {
          image_url: imagePath
        },
        class_type: 'LoadImageFromURL',
        _meta: {
          title: '从url加载图片'
        }
      },
      46: {
        inputs: {
          model: 'wd-v1-4-moat-tagger-v2',
          threshold: 0.35,
          character_threshold: 0.85,
          replace_underscore: false,
          trailing_comma: false,
          exclude_tags: '',
          tags: '1girl, solo, long_hair, brown_hair, black_hair, hair_ornament, dress, brown_eyes, jewelry, standing, flower, outdoors, hair_flower, white_dress, snow, mountain, realistic',
          image: [
            '42',
            0
          ]
        },
        class_type: 'WD14Tagger|pysssss',
        _meta: {
          title: 'WD14 Tagger 🐍'
        }
      }
    }
    const clientId = uuidv4()
    const data = {
      prompt: promptData,
      client_id: clientId
    }
    // 发送 Prompt 请求
    const sendPromptRequest = async () => {
      try {
        console.log('get prompt response', data)
        return genPrompt(data)
      } catch (error) {
        console.error('发送作图请求失败：', error)
      }
    }

    const fetchImageFilename = async (promptId) => {
      try {
        // 直接使用该实例请求历史记录
        const historyRequest = axios.create({
          baseURL: getLastUsedBaseUrl(),
          timeout: 5000,
          headers: {
            'Content-Type': 'application/json'
          }
        })

        const response = await historyRequest.get(`/history/${promptId}`)
        const promptInfo = response.data[promptId]
        const promptIndex = 2 // prompt信息的下标
        const inputIndex = 41 // prompt信息组件名的下标
        if (promptInfo.status.status_str === 'success') {
          const tmp = JSON.parse(promptInfo.prompt[promptIndex][inputIndex].inputs.filename)
          imageList.push(genOssImage(tmp[0]))
        } else {
          console.error('获取历史记录失败，状态码：', response.status)
        }
        return imageList
      } catch (error) {
        console.error('获取图像文件名失败：', error)
      }
    }

    const listenToProgress = (promptId) => {
      const ws = new WebSocket(`${getLastUsedBaseUrl()}/ws?clientId=${clientId}`)
      const wsTimeout = setTimeout(() => {
        Message.warning('网络连接超时,请重新尝试!')
        ws.close()
      }, 2000)

      ws.onopen = () => {
        console.log('提交服务器开始生成...')
        // console.log(T_SD_TTI)
        clearTimeout(wsTimeout)
      }
      ws.onmessage = async (event) => {
        clearTimeout(wsTimeout)
        const data = event.data
        if (typeof data === 'string') {
          try {
            const msg = JSON.parse(event.data)
            if (msg.type === 'executing') {
              const data = msg.data
              if (data.node === null && data.prompt_id === promptId) {
                ws.close()
                const images = await fetchImageFilename(promptId)
                // 返回对象
                const obj = {
                  images: images,
                  status: false
                }
                resolve(obj)
              }
            } else if (msg.type === 'progress') {
              const value = msg.data.value
              const max = msg.data.max
              const current = (value / max * 100).toFixed(2)
              if (progressCallback && typeof progressCallback === 'function') {
                progressCallback(current)
              }
            }
          } catch (error) {
            console.log('获取结果失败，请重试')
          }
        }
      }
      ws.onerror = (error) => {
        reject(error)
      }
      ws.onclose = async () => {
        try {
          const index = cudaIndexNum()
          await cuda.changeCudaCurrentStatus(index, 'leisure')
        } catch (error) { console.log(error) }
      }
    }

    (async () => {
      const result = await sendPromptRequest()
      if (result && result.prompt_id) {
        listenToProgress(result.prompt_id)
      }
    })()
  })
}
export {
  boardpicture
}
